import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import audioManager from '../utils/AudioManager';
import { saveAudioPlay } from '../utils/firebase';
import StampResultModal from './StampResultModal';
import '../styles/InfoModal.css';

export default function StampModal({ isOpen, onClose, stamp, onStampGet, sessionId }) {
  const { t } = useTranslation();

  const [completedSet, setCompletedSet] = useState(new Set());
  const [resultOpen, setResultOpen] = useState(false);
  // ★ 1回目:再生 → 2回目:停止 → 3回目:最初から再生、のトグル用state
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('completedStamps');
    if (saved) setCompletedSet(new Set(JSON.parse(saved)));
  }, []);

  // スポットが切り替わったら再生状態の表示もリセット
  useEffect(() => {
    setIsAudioPlaying(false);
  }, [stamp?.id]);

  const isCompleted = !!(stamp && stamp.id && completedSet.has(stamp.id));
  const isNearby = !!stamp?.isNearby;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  const handlePlayAudio = async () => {
    if (!stamp?.audioPath) return;

    // 再生中に押された場合は停止だけして終了
    if (isAudioPlaying) {
      audioManager.stop();
      setIsAudioPlaying(false);
      return;
    }

    // 停止中に押された場合は（1回目でも3回目でも）最初から再生
    setIsAudioPlaying(true);
    try {
      await audioManager.play(stamp.audioPath, {
        onEnded: () => setIsAudioPlaying(false)
      });
    } catch (err) {
      audioManager.playSimple(stamp.audioPath, {
        onEnded: () => setIsAudioPlaying(false)
      });
    }

    // ★ 位置情報(saveLocation)と同じセッション単位で再生回数をカウント
    //    （失敗しても再生自体には影響させない）
    saveAudioPlay(sessionId, stamp.id).catch((err) => {
      console.error('Failed to record audio play count:', err);
    });
  };

  const handleStampGet = () => {
    if (!stamp?.id || isCompleted || !isNearby) return;

    const next = new Set(completedSet);
    next.add(stamp.id);
    setCompletedSet(next);
    localStorage.setItem('completedStamps', JSON.stringify([...next]));

    onStampGet?.(stamp.id);

    setResultOpen(true);
  };

  const closeResult = () => setResultOpen(false);
  const handleReturnToMap = () => {
    setResultOpen(false);
    onClose?.();
  };

  return (
    <>
      {isOpen && stamp ? (
        <div className="modal-overlay" onClick={handleOverlayClick}>
          <div className="info-modal">
            <div className="info-content">
              {stamp.image && (
                <img src={stamp.image} alt={stamp.name} className="info-image" />
              )}

              <div className="info-header">
                <h2 className="info-title">{stamp.name}</h2>
                {stamp.audioPath && (
                  <button
                    className="audio-play-button"
                    onClick={handlePlayAudio}
                    title={t('map.buttons.playAudio')}
                    aria-label={t('map.buttons.playAudio')}
                    aria-pressed={isAudioPlaying}
                  >
                    {isAudioPlaying ? '⏸️' : '🔊'}
                  </button>
                )}
              </div>

              {stamp.description && (
                <p className="info-description">{stamp.description}</p>
              )}

              {/*
              {stamp.onRouteSearch && (
                <button
                  onClick={stamp.onRouteSearch}
                  disabled={stamp.routeLoading}
                  style={{
                    marginTop: '12px',
                    padding: '10px',
                    width: '100%',
                    borderRadius: '8px',
                    border: 'none',
                    background: '#ff4d4f',
                    color: '#fff',
                    fontWeight: 'bold',
                    cursor: stamp.routeLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {stamp.routeLoading ? '経路検索中...' : 'ここまでの経路'}
                </button>
              )}
              */}

              {stamp.id && (
                <button
                  className={`stamp-get-button ${
                    isCompleted || !isNearby ? 'disabled' : ''
                  }`}
                  onClick={handleStampGet}
                  disabled={isCompleted || !isNearby}
                >
                  {isCompleted
                    ? t('stamp.collected')
                    : !isNearby
                    ? t('stamp.moveCloser', 'スポットに近づいてください')
                    : t('stamp.getStamp')}
                </button>
              )}
            </div>

            <button className="close-button" onClick={onClose}>
              {t('map.buttons.close')}
            </button>
          </div>
        </div>
      ) : null}

      <StampResultModal
        isOpen={resultOpen}
        onClose={closeResult}
        onReturnToMap={handleReturnToMap}
        isCorrect={true}
      />
    </>
  );
}